import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { AdminOrderListVM } from 'src/app/models/customer/customer.model';
import { PagingModel } from 'src/app/models/paging/paging.model';
import { AdminQuoteListVM, AllQuoteList } from 'src/app/models/quoteModel/quote.model';
import { AlertifyService } from 'src/app/services/Common/alertify.service';
import { HomePageService } from 'src/app/services/home-page.service';
import { QuoteService } from 'src/app/services/quote.service';
import { DeleteQuoteComponent } from '../delete-quote/delete-quote.component';

@Component({
  selector: 'app-admin-quote-listing',
  templateUrl: './admin-quote-listing.component.html',
  styleUrls: ['./admin-quote-listing.component.css']
})
export class AdminQuoteListingComponent implements OnInit {
  adminQuoteList: AdminQuoteListVM = new AdminOrderListVM();
  adminAllQuoteList: AllQuoteList = new AllQuoteList();
  startDate: string;
  endDate: string;
  Loader: boolean = false;
  productId: number;
  pageNumber: number = 1;
  pagingModel: PagingModel;
  totalPages: number;
  showStartDateError: boolean = false;
  showEndDateError: boolean = false;
  maxDate: any = new Date();
  
  constructor(private homePageService: HomePageService, private router: Router, private modalService: NgbModal, private alertify: AlertifyService, private requestQuote: QuoteService) {
    this.pagingModel = new PagingModel();
    this.pagingModel.pageNumber = 1;
    if (this.totalPages == undefined || this.totalPages == 0) {
      this.totalPages = 1;
    }
  }

  ngOnInit() {
    this.adminQuoteListing();
  }

  onDateChange() {
    this.showStartDateError = Object.prototype.toString.call(this.startDate) === "[object Date]" ? true : false;
  }

  onEndDateChange() {
    this.showEndDateError = Object.prototype.toString.call(this.endDate) === "[object Date]" ? true : false;
  }

  resetFilter() {
    this.startDate = "";
    this.endDate = "";
    this.adminQuoteList.PageNumber = 1;
    this.adminQuoteList.PageSize = 10;
    this.totalPages = 1;
    this.pageNumber = 1;
    this.adminQuoteListing();
  }

  filter() {
    this.showStartDateError = Object.prototype.toString.call(this.startDate) === "[object Date]" ? true : false;
    this.showEndDateError = Object.prototype.toString.call(this.endDate) === "[object Date]" ? true : false;
    this.adminQuoteList.PageNumber = 1;
    this.adminQuoteList.PageSize = 10;
    this.adminQuoteList.StartDate = this.startDate;
    this.adminQuoteList.EndDate = this.endDate;
    this.adminQuoteListing();
  }

  adminQuoteListing() {
    this.adminQuoteList.StartDate = this.startDate;
    this.adminQuoteList.EndDate = this.endDate;
    this.Loader = true;
    this.requestQuote.showAdminAllQuotelisting(this.adminQuoteList)
      .subscribe(response => {
        this.Loader = false;
        var responseBody = JSON.parse(response._body);
        if (responseBody.isSuccess) {
          this.adminAllQuoteList.AdminQuoteList = responseBody.responseData;
          this.adminAllQuoteList.AdminQuoteList.forEach((element, index) => {
            this.adminAllQuoteList.AdminQuoteList[index].imageLoader = true;
            this.productId = element.productId;
            this.homePageService.ProductImageList(this.productId)
              .subscribe((response) => {
                let responseimage = JSON.parse(response._body)
                if (responseimage.isSuccess) {
                  this.adminAllQuoteList.AdminQuoteList[index].productImage = responseimage.responseData;
                  this.adminAllQuoteList.AdminQuoteList[index].imageLoader = false;
                } (err) => {
                }
              })
          });
          this.adminAllQuoteList.TotalPages = responseBody.totalPages;
          this.totalPages = this.adminAllQuoteList.TotalPages == undefined ? 0 : this.adminAllQuoteList.TotalPages;
        } else {
          this.alertify.error(responseBody.responseMessage);
          this.Loader = false;
        }
      });
  }

  loadPage(pagingModel: PagingModel) {
    this.adminQuoteList.PageNumber = pagingModel.pageNumber;
    this.adminQuoteList.PageSize = pagingModel.pageSize;
    this.adminQuoteListing();
  }

  productImage(item) {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/product-page/' + item.productId]));
    window.open('#' + url, '_blank');
  }

  singleQuoteDetail(item) {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/quote-view-list/' + item.productId + '/' + item.id]));
    window.open('#' + url, '_blank');
  }

  singleQuoteDelete(item) {
      var modalConfig = new NgbModalConfig();
      modalConfig.size = "lg";
      modalConfig.centered = true;
      modalConfig.backdrop = false;
      modalConfig.keyboard = false;
      this.requestQuote.passId(item.id);
      let modalRef = this.modalService.open(DeleteQuoteComponent, modalConfig);
      modalRef.result.then(() => {
      }, (reason) => {
        this.adminQuoteListing();
      })
  }
}
